import { DI, resolve } from 'aurelia';
import { doc, onSnapshot } from 'firebase/firestore';
import { IFirebase } from './firebase';
import { DEFAULT_GAME_CONFIG, DEFAULT_TOKENS, DEFAULT_PAYTABLE, type GameConfig, type TokenConfig, type Paytable } from '@shared/index';

export interface IConfig {
  game: GameConfig;
  tokens: TokenConfig[];
  paytable: Paytable;
  loaded: boolean;
  token(symbol: string): TokenConfig | undefined;
  start(): void;
  stop(): void;
}

export const IConfig = DI.createInterface<IConfig>('IConfig', (x) => x.singleton(ConfigService));

export class ConfigService implements IConfig {
  game: GameConfig = { ...DEFAULT_GAME_CONFIG };
  tokens: TokenConfig[] = DEFAULT_TOKENS;
  paytable: Paytable = DEFAULT_PAYTABLE;
  loaded = false;
  private fb = resolve(IFirebase);
  private unsubs: (() => void)[] = [];

  token(symbol: string): TokenConfig | undefined {
    return this.tokens.find((t) => t.symbol === symbol);
  }

  start(): void {
    if (this.unsubs.length) return;
    const db = this.fb.db;
    this.unsubs.push(onSnapshot(doc(db, 'config', 'game'), (s) => { if (s.exists()) this.game = { ...DEFAULT_GAME_CONFIG, ...(s.data() as GameConfig) }; this.loaded = true; }));
    this.unsubs.push(onSnapshot(doc(db, 'config', 'tokens'), (s) => { const t = s.data()?.tokens as TokenConfig[] | undefined; if (t?.length) this.tokens = t; }));
    this.unsubs.push(onSnapshot(doc(db, 'config', 'paytable'), (s) => {
      if (!s.exists()) return;
      const raw = s.data() as any;
      const spots: Paytable['spots'] = {};
      for (const [sp, table] of Object.entries(raw.spots ?? {})) {
        const t: Record<number, number> = {};
        for (const [h, m] of Object.entries(table as Record<string, number>)) t[Number(h)] = Number(m);
        spots[Number(sp)] = t;
      }
      this.paytable = { spots, headsTails: raw.headsTails ?? DEFAULT_PAYTABLE.headsTails };
    }));
  }

  stop(): void {
    this.unsubs.forEach((u) => u());
    this.unsubs = [];
  }
}
